import styled from 'styled-components';
import { EmptyButton, getTheme } from 'mol-ui';

export const Container = styled(EmptyButton)`
    align-items: center;
    color: ${ getTheme('textColor') };
    display: flex;
    flex-direction: row;
    font-size: 14px;
    margin-bottom: 15px;
    width: max-content;
`;

export const IconContainer = styled(EmptyButton)`
    margin-left: 10px;
`;

export const ModalButtonContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: space-evenly;
`;

export const ModalContent = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const ModalTitle = styled.div`
    margin-bottom: 20px;
    text-align: center;
`;

export const Text = styled.span`
    margin: 0px 5px;
`;
